var track = {
    text1:"PUNTOS GENERADOS:",
    pending:"PENDIENTES",
    available:"DISPONIBLES",
    text2:"Reservas Actuales",
    bookingSource: "Origen de Reserva",
    bookingNumber: "Numero de Reserva",
    clientName: "Nombre del Cliente",
    resort: "Hotel",
    room: "Tipo de Habitación",
    points: "Puntos Ganados",
    status: "Estado",
    remptioHistory: "Historial de Recompensas:",
    pointsRedeemed: "Puntos Usados",
    rewardType: "Tipo de Recompensa",
    dateReddem: "Fecha",
    awardboxText1: "Obtener una recompensa:",
    awardboxText2:"Tipo de Recompensa",
    awardboxText3:"Puntos a usar",
    awardboxSelect:"Seleccionar",
    awardboxText4:"Agregar otra recompensa +",
    awardboxText5:"Eliminar Fila -",
    awardboxText6:"Por favor envíe mi(s) recompensa(s) a:",
    awardboxFielName:"Nombre Completo",
    awardboxFielEmail:"Email",
    awardboxFielStreet:"Calle",
    awardboxFielApt:"Numero #",
    awardboxFielCity:"Ciudad",
    awardboxFielProvince:"Estado/Provincia",
    awardboxFielZip:"Codigo Postal",
    awardboxFielCountry:"Pais",
    awardboxFielBankName:"Nombre del Banco",
    awardboxFielBankClabe:"Numero de Clabe",
    awardboxFielBankAccount:"Numero de cuenta",
    awardboxFielBankBeneficiary:"Beneficiario de la cuenta",
    awardboxFielCurp:"CURP",
    awardboxFielRfc:"RFC",
    sendbtn: "Enviar",
    note: "Nota: El  premio será depositado vía transferencia, por favor envíe su caratula bancaria por correo. Los certificados de estadías en hoteles serán enviados por correo electrónico.",
    error: "Seleccione el tipo de premio y puntos",
    error2: "Ingrese Nombre Completo",
    error3: "Ingrese un correo electrónico",
    error4: "No puedes canjear el premio, no tienes puntos disponibles.",
    records: "0 Reservas",
    loading: "Cargando...",
    note1:"No pueden usarse más de dos habitaciones en la misma fecha.",
    note2_deleted:"(No aplica en, semana santa, pascua).",
    note2:"(Favor de comunicarse al hotel para  verificar  disponibilidad)",
    processingNoticeTitle:"Información de procesamiento",
    processingNoticeLead:"Las solicitudes se procesan en el orden en que se reciben y pueden tardar de 7 a 10 días hábiles.",
    processingNoticeBody:"Una vez aprobadas y procesadas, las tarjetas de regalo Tango se enviarán por correo electrónico directamente al agente que califica.",
    processingNoticeImportantTitle:"Importante para solicitudes de tarjeta Tango",
    processingNoticeImportantBody:"Incluya una copia de su formato TAX ID completo para que podamos procesar su solicitud a tiempo. Envíe los formatos TAX ID a marivalrewards@marivalresorts.com.",
    processingNoticeBlackout:"Pueden aplicar fechas restringidas durante Easter, Summer, Thanksgiving, Holy Week y días festivos en México.",
    Total_Points:"PUNTOS TOTALES",
    redeem_a: "Para redimir su certificado de cortesía en Marival Armony o Marival Distinct, deberá acumular 6 puntos con reservas realizadas en cualquiera de estos dos Resorts. Los puntos ganados por reservas ingresadas en estas dos propiedades son combinables.",
    redeem_b: "Las reservas realizadas en Marival Emotions no califican para certificados de cortesía en Marival Armony o Marival Distinct.",
    redeem_c: "Las reservas realizadas en Marival Armony o Marival Distinct, también se podrán canjear por estancias en Marival Emotions, en una habitación Resort o en una suite de 1 recámara.",
    redeem_d: "Para canjear su certificado de cortesía en una Suite de una recámara de Marival Emotions, deberá acumular 6 puntos con reservas realizadas en cualquiera de nuestras Suites en Marival Emotions, o con reservas ingresadas en Marival Armony y Marival Distinct.",
    redeem_e: "Las reservas realizadas en las categorías de Suites, también se podrán canjear por estancias en habitación Resort en Marival Emotions.",
    redeem_f: "Las reservas realizadas en la categoría Resort no califican para estancias en Suite de una recámara en Marival Emotions, ni para estancias en Marival Armony y Marival Distinct.",
    redeem_g: "Para redimir su certificado de cortesía en habitación Resort en Marival Emotions, deberá acumular 6 puntos con reservas de cualquier categoría, en cualquiera de nuestros tres Resorts.",
    redeem_h: "Todas las reservas en nuestros tres Resorts califican para una estancia en una habitación Resort en Marival Emotions.",

    redeem_a_1:"To redeem your complimentary stay at Marival Armony or Marival Distinct, you must have validated registered bookings at either Armony or Distinct to qualify.",
    redeem_b_1: "Bookings made at Marival Emotions do not qualify for stays at Marival Armony or Marival Distinct.",
    redeem_c_1: "Bookings made at Marival Armony or Marival Distinct may also be redeemed for stays at Marival Emotions.",
    redeem_d_1: "Confirmed complimentary stays will be processed in standard room categories at each resort.  Room upgrades are subject to availability and/or additional cost.  Which agent will be responsible for.  ",
    redeem_e_1: "",
    redeem_f_1: "",
    redeem_g_1: "",
    redeem_h_1: ""
}
module.exports = track
